import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/010-upload.png';
const _withScopeId = n => (_pushScopeId("data-v-1cd08af8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "single main"
};
const _hoisted_2 = {
  key: 0,
  class: "upload-img-show"
};
const _hoisted_3 = {
  class: "box"
};
const _hoisted_4 = {
  class: "form-box-box"
};
const _hoisted_5 = {
  class: "upload-logo-div"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "upload-icon",
  src: _imports_0
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, [/*#__PURE__*/_createTextVNode("将图片拖拽至此，或 "), /*#__PURE__*/_createElementVNode("em", null, "点击上传")], -1));
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "slider-container"
};
const _hoisted_10 = {
  class: "slider-value"
};
const _hoisted_11 = {
  class: "slider-container"
};
const _hoisted_12 = {
  class: "slider-value"
};
const _hoisted_13 = {
  class: "slider-container"
};
const _hoisted_14 = {
  class: "slider-value"
};
const _hoisted_15 = {
  class: "action-buttons"
};
const _hoisted_16 = {
  class: "img-box-r"
};
const _hoisted_17 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_slider = _resolveComponent("el-slider");
  const _component_el_color_picker = _resolveComponent("el-color-picker");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.dialogVisible ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, null, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: "上传图片进行图片位置旋转",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_upload, {
        class: "upload",
        drag: "",
        action: "#",
        "list-type": "picture-card",
        "auto-upload": false,
        "on-success": $options.onSuccess2,
        "on-change": $options.onChange
      }, {
        default: _withCtx(() => [_hoisted_6, _hoisted_7]),
        file: _withCtx(({
          file
        }) => [_createElementVNode("img", {
          class: "el-upload-list__item-thumbnail",
          src: file.url,
          alt: ""
        }, null, 8, _hoisted_8)]),
        _: 1
      }, 8, ["on-success", "on-change"])])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "图片旋转角度",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_slider, {
        modelValue: $data.logoStyle.rotate,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.logoStyle.rotate = $event),
        class: "slider-width",
        "show-input": "",
        size: "small",
        "show-stops": "",
        step: 0.1,
        min: 0,
        max: "360"
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_10, _toDisplayString($data.logoStyle.rotate) + "°", 1)])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "图片透明度",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_slider, {
        modelValue: $data.logoStyle.opacity,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.logoStyle.opacity = $event),
        class: "slider-width",
        "show-input": "",
        size: "small",
        "show-stops": "",
        step: 0.01,
        min: 0.01,
        max: "1"
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_12, _toDisplayString(($data.logoStyle.opacity * 100).toFixed(0)) + "%", 1)])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "图片圆角",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_slider, {
        modelValue: $data.logoStyle.borderRadius,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.logoStyle.borderRadius = $event),
        class: "slider-width",
        "show-input": "",
        size: "small",
        "show-stops": "",
        step: 1,
        min: 0,
        max: "2000"
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_14, _toDisplayString($data.logoStyle.borderRadius) + "px", 1)])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "旋转后图片背景色",
      "label-position": "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_color_picker, {
        modelValue: $data.logoStyle.bg,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.logoStyle.bg = $event),
        size: "large",
        "show-alpha": "",
        class: "color-picker"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: $options.downloadAll,
        disabled: _ctx.disabledBtn,
        class: "download-btn"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.downloadTxt), 1)]),
        _: 1
      }, 8, ["onClick", "disabled"]), _createVNode(_component_el_button, {
        onClick: _cache[4] || (_cache[4] = $event => $data.dialogVisible = false),
        class: "close-btn"
      }, {
        default: _withCtx(() => [_createTextVNode(" 关闭 ")]),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
    class: "img-box-logo",
    style: _normalizeStyle(`
              height: ${$data.h};
              width: ${$data.w};
              background-color: ${$data.logoStyle.bg};
            `),
    ref: "imgBoxLogo"
  }, [_createElementVNode("img", {
    ref: "logoSpan",
    class: "el-upload-list__item-thumbnail img-img",
    style: _normalizeStyle(`
                width: ${$data.logoStyle.imgwidth}px;
                height: ${$data.logoStyle.imgheight}px;
                opacity: ${$data.logoStyle.opacity};
                transform: rotate(${$data.logoStyle.rotate}deg) scale(${$data.logoStyle.scale});
                border-radius: ${$data.logoStyle.borderRadius}px;
                background-color: ${$data.logoStyle.bg};
              `),
    src: $data.logoStyle.logoImg
  }, null, 12, _hoisted_17)], 4)])])])) : _createCommentVNode("", true)]);
}